const domain = "async-action";
class AsyncAction {
  request;
  success;
  failure;
}
export {
  AsyncAction,
  domain
};
//# sourceMappingURL=type.js.map
